import { SchedulerProConfig } from '@bryntum/schedulerpro';

import { ScheduleConstants } from '@/common/bryntum/constants';

export const baseSchedulerProConfig: Partial<SchedulerProConfig> = {
  autoAdjustTimeAxis: false,
  barMargin: ScheduleConstants.MARGIN.BAR,
  enableEventAnimations: true,
  milestoneLayoutMode: 'data',
  milestoneTextPosition: 'always-outside',
  preserveScrollOnDatasetChange: true,
  projectProgressReporting: null,
  resourceMargin: ScheduleConstants.MARGIN.RESOURCE,
  rowHeight: ScheduleConstants.ROW_HEIGHT,
};
